export function stickyButtonHandler() {
  const stickyButton = document.querySelector('.sticky-button');
  const phoneInput = document.querySelector('.create-quote-form input[type="tel"]');
  const getQuoteButtons = document.querySelectorAll('.under-banner .get-quote-btn');

  // якщо немає кнопки — взагалі нічого не робимо
  if (!stickyButton) return;

  // show/hide on scroll
  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      stickyButton.classList.add('show');
    } else {
      stickyButton.classList.remove('show');
    }
  });

  stickyButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    if (phoneInput) {
      setTimeout(() => {
        phoneInput.focus();
      }, 400);
    }
  });

  // кнопки get quote
  if (getQuoteButtons.length && phoneInput) {
    getQuoteButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => {
          phoneInput.focus();
        }, 400);
      });
    });
  }
}